import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "../lib/apiService";

export const RouteGuard = (props) => {
  function hasJWT() {
    return getAuthToken() ? true : false;
  }

  return <>{hasJWT() ? props.children : <Navigate to="/verify" />}</>;
};
